module.exports = __webpack_public_path__ + "static/media/achterkant.2d786b01.jpg";